<template>
  <div class="flex-grow-1 d-flex flex-column overflow-hidden mt-n2">
    <!-- 搜索条件卡片 -->
    <v-card class="rounded-xl card-bg card-bd flex-shrink-0 px-6 py-5" variant="elevated" elevation="0">
      <div class="d-flex align-center flex-wrap ga-4">
        <div class="search-item">
          <span class="search-label">接口名称</span>
          <v-text-field v-model="queryParams.title" placeholder="请输入接口名称" variant="outlined" density="compact"
            hide-details rounded="xl" class="search-input" clearable @keyup.enter="handleQuery" />
        </div>
        <div class="search-item">
          <span class="search-label">操作人员</span>
          <v-text-field v-model="queryParams.operName" placeholder="请输入操作人员" variant="outlined" density="compact"
            hide-details rounded="xl" class="search-input" clearable @keyup.enter="handleQuery" />
        </div>
        <div class="search-item">
          <span class="search-label">操作地址</span>
          <v-text-field v-model="queryParams.operIp" placeholder="请输入操作地址" variant="outlined" density="compact"
            hide-details rounded="xl" class="search-input" clearable @keyup.enter="handleQuery" />
        </div>
        <div class="search-item">
          <span class="search-label">类型</span>
          <v-select v-model="queryParams.businessType" :items="operTypeItems" item-title="label" item-value="value"
            placeholder="操作类型" variant="outlined" density="compact" hide-details rounded="xl"
            class="search-input--select" clearable @update:model-value="handleQuery" />
        </div>
        <div class="search-item">
          <span class="search-label">状态</span>
          <v-select v-model="queryParams.status" :items="statusItems" item-title="label" item-value="value"
            placeholder="操作状态" variant="outlined" density="compact" hide-details rounded="xl"
            class="search-input--select" clearable @update:model-value="handleQuery" />
        </div>
        <div class="search-item">
          <span class="search-label">操作时间</span>
          <el-date-picker v-model="dateRange" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="YYYY-MM-DD HH:mm:ss" :default-time="defaultTime"
            class="search-date-picker" @change="handleQuery" />
        </div>

        <div class="search-actions d-flex ga-3 ml-auto">
          <v-btn color="#2655f1" rounded="xl" class="action-btn" @click="handleQuery">
            <v-icon start icon="mdi-magnify" />查询
          </v-btn>
          <v-btn variant="outlined" color="#2655f1" rounded="xl" class="action-btn" @click="resetQuery">
            <v-icon start icon="mdi-refresh" />重置
          </v-btn>
          <v-btn v-hasPermi="['monitor:operlog:export']" variant="outlined" color="#2655f1" rounded="xl"
            class="action-btn" :loading="exportLoading" @click="handleExport">
            <v-icon start icon="mdi-download" />导出
          </v-btn>
        </div>
      </div>
    </v-card>

    <!-- 表格内容 -->
    <v-card class="rounded-xl card-bg card-bd card-table flex-grow-1 d-flex flex-column overflow-hidden mt-3"
      variant="elevated" elevation="0" :loading="loading">
      <div class="table-wrapper flex-grow-1 overflow-hidden d-flex flex-column">
        <v-table fixed-header height="100%" style="width: 100%; background: transparent" class="gm-table border-none">
          <thead>
            <tr>
              <th style="width: 110px">日志编号</th>
              <th style="width: 180px">接口名称</th>
              <th style="width: 120px">操作类型</th>
              <th style="width: 130px">
                <span class="sort-th" @click="toggleSort('operName')">
                  操作人员<v-icon size="16" :icon="sortIcon('operName')" />
                </span>
              </th>
              <th style="width: 140px">操作地址</th>
              <!-- <th style="width: 160px">操作地点</th> -->
              <th style="width: 110px">操作状态</th>
              <th style="width: 190px">
                <span class="sort-th" @click="toggleSort('operTime')">
                  操作时间<v-icon size="16" :icon="sortIcon('operTime')" />
                </span>
              </th>
              <!-- <th style="width: 120px">
                <span class="sort-th" @click="toggleSort('costTime')">
                  消耗时间<v-icon size="16" :icon="sortIcon('costTime')" />
                </span>
              </th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in list" :key="row.operId">
              <td class="text-medium-emphasis">{{ row.operId }}</td>
              <td :title="row.title">{{ row.title || '--' }}</td>
              <td>{{ operTypeLabel(row.businessType) }}</td>
              <td :title="row.operName">{{ row.operName || '--' }}</td>
              <td>{{ row.operIp || '--' }}</td>
              <!-- <td :title="row.operLocation">{{ row.operLocation || '--' }}</td> -->
              <td>
                <v-chip :color="String(row.status) === '0' ? '#33BE36' : '#FF6A46'" variant="tonal" class="status-chip">
                  {{ statusLabel(row.status) }}
                </v-chip>
              </td>
              <td class="text-medium-emphasis">{{ parseTime(row.operTime) || '--' }}</td>
              <!-- <td>{{ row.costTime != null ? row.costTime + '毫秒' : '--' }}</td> -->
            </tr>
          </tbody>
        </v-table>
      </div>
      <div v-if="!loading && list.length === 0" class="text-center py-12 text-medium-emphasis">暂无操作日志数据</div>
      <div class="px-6 pb-4 d-flex justify-end">
        <TablePagination v-model="queryParams.pageNum" v-model:page-size="queryParams.pageSize" :total="total"
          :has-sizes="true" :has-jump="true" @change="getList" />
      </div>
    </v-card>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import TablePagination from '@/components/TablePagination/index.vue'
import { addDateRange, parseTime, selectDictLabel } from '@/utils/ruoyi'
import { useDict } from '@/utils/dict'
import { list as listOperlog, exportOperlog } from '@/api/monitor/operlog'

const { sys_oper_type, sys_common_status } = useDict('sys_oper_type', 'sys_common_status')

/** v-select 需要普通数组，字典是 ref，这里透传 .value */
const operTypeItems = sys_oper_type
const statusItems = sys_common_status

const loading = ref(false)
const exportLoading = ref(false)
const total = ref(0)
const list = ref([])
const dateRange = ref([])
const defaultTime = [new Date(2000, 0, 1, 0, 0, 0), new Date(2000, 0, 1, 23, 59, 59)]

/** 默认按操作时间倒序，与 ruoyi 一致 */
const DEFAULT_SORT = { prop: 'operTime', order: 'descending' }

const queryParams = ref({
  pageNum: 1,
  pageSize: 10,
  operIp: undefined,
  title: undefined,
  operName: undefined,
  businessType: undefined,
  status: undefined,
  orderByColumn: DEFAULT_SORT.prop,
  isAsc: DEFAULT_SORT.order
})

/** 每页条数变化时 TablePagination 已重置页码，这里只需重新拉取 */
watch(() => queryParams.value.pageSize, () => getList())

function operTypeLabel(v) {
  return selectDictLabel(sys_oper_type.value ?? [], v) || '--'
}

function statusLabel(v) {
  return selectDictLabel(sys_common_status.value ?? [], v) || '--'
}

/** 表头排序：点击在 降序 → 升序 之间切换，与 ruoyi 的 sort-orders 一致 */
function toggleSort(prop) {
  const cur = queryParams.value
  if (cur.orderByColumn === prop) {
    cur.isAsc = cur.isAsc === 'descending' ? 'ascending' : 'descending'
  } else {
    cur.orderByColumn = prop
    cur.isAsc = 'descending'
  }
  cur.pageNum = 1
  getList()
}

function sortIcon(prop) {
  if (queryParams.value.orderByColumn !== prop) return 'mdi-unfold-more-horizontal'
  return queryParams.value.isAsc === 'ascending' ? 'mdi-arrow-up' : 'mdi-arrow-down'
}

async function getList() {
  loading.value = true
  try {
    const res = await listOperlog(addDateRange(queryParams.value, dateRange.value))
    list.value = res?.rows ?? []
    total.value = res?.total ?? 0
  } catch (e) {
    console.warn(e)
  } finally {
    loading.value = false
  }
}

function handleQuery() {
  queryParams.value.pageNum = 1
  getList()
}

function resetQuery() {
  dateRange.value = []
  queryParams.value = {
    pageNum: 1,
    pageSize: queryParams.value.pageSize,
    operIp: undefined,
    title: undefined,
    operName: undefined,
    businessType: undefined,
    status: undefined,
    orderByColumn: DEFAULT_SORT.prop,
    isAsc: DEFAULT_SORT.order
  }
  getList()
}

async function handleExport() {
  exportLoading.value = true
  try {
    const blob = await exportOperlog(addDateRange(queryParams.value, dateRange.value))
    const url = window.URL.createObjectURL(new Blob([blob]))
    const link = document.createElement('a')
    link.href = url
    link.download = `操作日志_${Date.now()}.xlsx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (e) {
    console.warn(e)
  } finally {
    exportLoading.value = false
  }
}

onMounted(() => {
  getList()
})
</script>

<style scoped lang="scss">
.card-bg {
  background: #fff;
  backdrop-filter: blur(8px);
}

.card-bd {
  border-radius: 0 0 30px 30px !important;
}

.card-table {
  padding: 24px 16px 0;
  border-radius: 30px !important;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  .search-label {
    white-space: nowrap;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
  }

  .search-input {
    width: 200px;
  }

  .search-input--select {
    width: 180px;
  }
}

.action-btn {
  min-width: 90px;
  height: 40px !important;
}

/* el-date-picker 对齐 Vuetify 输入框的圆角描边风格 */
.search-date-picker {
  width: 300px;

  :deep(.el-input__wrapper),
  :deep(.el-range-editor.el-input__wrapper) {
    width: 100%;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.24);
    border-radius: 999px;
    box-shadow: none;
    padding: 0 16px;
    min-height: 40px;
    height: 40px;

    &.is-active,
    &:hover {
      border-color: #2655f1;
    }
  }
}

.sort-th {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: #2655f1;
  }
}

.gm-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;

  :deep(.v-table__wrapper) {
    overflow-x: auto !important;
  }

  :deep(thead tr) {
    background: #f8fafc !important;
  }

  :deep(th) {
    font-weight: 600 !important;
    color: rgba(0, 0, 0, 0.8) !important;
    border: none !important;
    background: #f8fafc !important;
    height: 56px !important;
    padding: 0 24px !important;
    white-space: nowrap;
  }

  :deep(td) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.04) !important;
    height: 56px !important;
    padding: 0 24px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 0;
  }
}

.status-chip {
  min-width: 60px;
  height: 28px !important;
  line-height: 28px !important;
  justify-content: center;
  border: 1px solid currentColor !important;
}
</style>
